const urls = {
  getPreSignedURL: '/ppt-plugin/image_upload_url',
} as const;

export default urls;
